import {
    METHOD_POST,
    SERVER_URL,
    METHOD_GET,
    METHOD_PUT
} from '../constants/api';
import {
    headersAuthSendReceiveJson,
} from '../headers';
import { apiHandleResponse } from '../../util/api';

const getRCMAssignmentList = () => {
    return fetch(`${SERVER_URL}/api/v1/cms/configuration/rcmteam/list`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

const setPrecedence = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/configuration/rcmteam/Precedences`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options)
    }).then(apiHandleResponse);
};

const createRcmTeam = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/configuration/rcmteam`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options)
    }).then(apiHandleResponse);
};

const updateRcmTeam = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/configuration/rcmteam`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options)
    }).then(apiHandleResponse);
};




const getRCMTeamDependencies = (id) => {
    return fetch(`${SERVER_URL}/api/v1/cms/configuration/rcmteam/dependencies/${id}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};


const deleteRcmTeam = (options) => {
    return fetch(`${SERVER_URL}/api/v1/cms/configuration/rcmteam/delete`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options)
    }).then(apiHandleResponse);
};

const getRCMAssignmentHistory = (id) => {
    return fetch(`${SERVER_URL}/api/v2/cms/analyse/rcmteam/history/${id}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};


const updateRCMTeam = (analysisId,rcmTeamId) => {
    return fetch(`${SERVER_URL}/api/v2/cms/analyse/${analysisId}/rcmteam/${rcmTeamId}`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify({})
    }).then(apiHandleResponse);
};

const updateBulkClaimsRCMTeam = (options) => {
    return fetch(`${SERVER_URL}/api/v2/cms/analyses/rcmteam`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(options)
    }).then(apiHandleResponse);
};

const getAllRCMTeamsList = () => {
    return fetch(`${SERVER_URL}/api/v2/cms/analyse/rcmteam/list`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};





export {
    getRCMAssignmentList,
    setPrecedence,
    createRcmTeam,
    updateRcmTeam,
    getRCMTeamDependencies,
    deleteRcmTeam,
    getRCMAssignmentHistory,
    updateRCMTeam,
    updateBulkClaimsRCMTeam,
    getAllRCMTeamsList
    
};